import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import ExportAttachmentsContainer from "./exportAttachmentsContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useExportAttachmentsDialog(reloadHandler?: () => void) {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const displayExportAttachmentsDialog = async () => {
    dispatch(
      displayDialog({
        isOpen: false,
        title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.ExportAttachmentsDialogTitle),
        dialogType: DialogEnums.DialogType.Content,
        titleIcon: IconDefinitionConstants.WDocument,
        actions: [
          {
            text: LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Revisor.ExportAttachmentsActionButtonText
            ),
          },
        ],
        children: <ExportAttachmentsContainer reload={reloadHandler} />,
        maxWidth: "sm",
      })
    );
  };

  return { displayExportAttachmentsDialog };
}

export default useExportAttachmentsDialog;
